<template>
    <q-banner inline-actions v-if="isVisible" v-bind="$attrs">
        <slot></slot>
        <template v-slot:action>
            <q-btn flat color="white" icon="close" @click="isVisible = false" />
        </template>
    </q-banner>
</template>

<script>
import { ref } from "vue";

export default {
    name: "BannerWrapper",
    setup() {
        const isVisible = ref(true);
        return { isVisible };
    },
};
</script>
